import React, { useRef, useEffect, useState } from 'react';
import { Form, Input, notification } from '@ss/mtd-react';
import { Select } from '@block/plug';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import { getEnumByCategory } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

function LanguageStandard(props) {
  const formRefs = useRef<any[]>([]);
  const { type, data } = props;
  // 是否展示考试和分数
  const [showScoreAndExamination, setShowScoreAndExamination] = useState({});
  const { campusResumeDetail, socialResumeDetail, socialResumeFormRefStore, campusResumeFormRefStore } = useRootStore();
  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    store = socialResumeDetail;
    storeRef = socialResumeFormRefStore;
  }

  useEffect(() => {
    storeRef.changeRef('resumeLanguageListRef', formRefs.current);
    // 处理英语的考试和分数
    if (type === 'campus') {
      const newShowScoreAndExamination = {};
      data?.forEach((item, index) => {
        if (item.language === 'English') {
          newShowScoreAndExamination[index] = true;
        } else {
          newShowScoreAndExamination[index] = false;
        }
      });
      setShowScoreAndExamination(newShowScoreAndExamination);
    }
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    switch (formItemKey) {
      case 'languageName': {
        store.setResumeLanguageList(index, 'languageName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeLanguageList(index, 'language', formItemValue?.id ? formItemValue.id : '');
        if (type === 'campus') {
          if (formItemValue?.id === 'English') {
            setShowScoreAndExamination({
              ...showScoreAndExamination,
              [index]: true,
            });
          } else {
            setShowScoreAndExamination({
              ...showScoreAndExamination,
              [index]: false,
            });
            // 注释掉清空逻辑，保留用户之前填写的考试信息
            // 在提交时根据语言类型来决定是否包含这些字段
            // store.setResumeLanguageList(index, 'examinationId', '');
            // store.setResumeLanguageList(index, 'examinationName', '');
            // store.setResumeLanguageList(index, 'score', '');
          }
        }

        break;
      }
      case 'levelName': {
        store.setResumeLanguageList(index, 'levelName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeLanguageList(index, 'level', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      // 语言水平 只有英语的时候才有这个值
      case 'examinationName': {
        store.setResumeLanguageList(index, 'examinationId', formItemValue?.id ? formItemValue.id : '');
        store.setResumeLanguageList(index, 'examinationName', formItemValue?.name ? formItemValue.name : '');
        break;
      }
      // 语言分数 只有英语的时候才有这个值
      case 'score': {
        store.setResumeLanguageList(index, 'score', formItemValue ?? '');
        break;
      }
      default:
        store.setResumeLanguageList(index, formItemKey, formItemValue);
    }
  };

  const handleFetchData = async (category: string, filter, parentCategory?: string) => {
    let params: { category: string; filter?: string; parentCategory?: string } = { category, filter: filter || '' };
    if (parentCategory) {
      params = { ...params, parentCategory };
    }
    const res = await getEnumByCategory(params);
    return res;
  };

  const deleteResumeList = (index) => {
    if (type === 'campus') {
      if (data?.length <= 1) {
        notification.error({
          title: '错误',
          message: '请至少填写一段语言水平',
        });
        return false;
      }
    }
    store.deleteResumeList('resumeLanguageList', index);
    return true;
  };

  return (
    <div className="language_standard_edit model_edit">
      <div className="model_title">语言水平</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            className="modal_form"
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="languageName" span="11" labelWidth={0} required message="请填写语言类型">
              <div className="label">
                语言类型<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请输入"
                labelField="name"
                keyField="id"
                notFoundMessage="无数据，请输入其他"
                onFetchData={(filter: string) => handleFetchData('language', filter)}
              />
            </FormItem>
            <FormItem formItemKey="levelName" span="11" labelWidth={0} required message="请填写语言水平">
              <div className="label">
                语言水平<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请输入"
                labelField="name"
                keyField="id"
                onFetchData={(filter: string) => handleFetchData('languageLevel', filter)}
              />
            </FormItem>
            {showScoreAndExamination[index] && type === 'campus' ? (
              <FormItem formItemKey="examinationName" span="11" labelWidth={0} required message="请填写语言考试">
                <div className="label">
                  语言考试<span className="icon">*</span>
                </div>
                <Select
                  toFormItem
                  size="large"
                  placeholder="请输入"
                  labelField="name"
                  keyField="id"
                  onFetchData={(filter: string) => handleFetchData('languageExamination', filter, 'English')}
                />
              </FormItem>
            ) : null}
            {showScoreAndExamination[index] && type === 'campus' ? (
              <FormItem
                formItemKey="score"
                span="11"
                labelWidth={0}
                message="请填分数"
                rules={[
                  {
                    required: true,
                    message: '请填分数',
                  },
                  {
                    pattern: /^\d+(\.\d+)?$/,
                    message: '考试分数格式不正确',
                  },
                ]}
              >
                <div className="label">
                  考试分数<span className="icon">*</span>
                </div>
                <Input toFormItem size="large" placeholder="请输入" />
              </FormItem>
            ) : null}
          </Form>
          <div className="delete-list">
            <div onClick={() => deleteResumeList(index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div className="list_add" onClick={() => store.addResumeList('resumeLanguageList')}>
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加语言水平
      </div>
    </div>
  );
}

export default ModuleView(observer(LanguageStandard), 'languageStandard');
